export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    // force: true cancels any in-flight scrollTo and starts fresh from the
    // current position — without it, rapid consecutive anchor clicks make
    // Lenis compute targets off a still-moving position and overshoot.
    // onComplete: lazy images loading during the animation shift the layout,
    // so re-aim once with a short glide to land exactly on the target.
    window.__lenis.scrollTo(el, {
      offset: -72,
      force: true,
      onComplete: () => {
        const target = document.getElementById(id);
        if (target && window.__lenis) {
          window.__lenis.scrollTo(target, { offset: -72, force: true, duration: 0.35 });
        }
      },
    });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
